export default (path) => {
  /* istanbul ignore if */
  if (process.env.NODE_ENV === 'development' && typeof process.env.USE_BACKEND === 'undefined') {
    return `//localhost:3002/assets/media/frontend/json${path}`
  }
  if (path.indexOf('questions.json') >= 0) {
    return process.env.UMAMI_URL + '/api/questions/?format=json'
  }
  if (path.indexOf('profile.json') >= 0) {
    return process.env.UMAMI_URL + '/api/profile/'
  }
  return path
}
